import http from '@/http'

const PATH = '/sms/mailbox/messages'

export default {
    /**
     * @param {{}} params
     * @returns {Promise<void>}
     */
    async listMessages (params) {
        try {
            const response = await http.get(PATH, {params})
            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    }
}
